var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysisHub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40601 12.523L5.80801 9.121L8.63601 11.95L11.793 8.793L10 7H15V12L13.207 10.207L8.63601 14.778L5.80801 11.95L3.33301 14.424C4.45642 16.1149 6.18063 17.3154 8.15624 17.7823C10.1318 18.2493 12.2111 17.9477 13.9726 16.9387C15.7342 15.9297 17.0462 14.2888 17.6429 12.3484C18.2397 10.4081 18.0764 8.31341 17.1863 6.48893C16.2961 4.66446 14.7456 3.24663 12.8491 2.52274C10.9525 1.79886 8.8516 1.82307 6.97219 2.59047C5.09279 3.35787 3.57541 4.81106 2.72754 6.65556C1.87967 8.50006 1.76473 10.5979 2.40601 12.524V12.523ZM0.868008 14.081L0.858008 14.071L0.862008 14.067C0.291937 12.787 -0.0017877 11.4012 8.18577e-06 10C8.18577e-06 4.477 4.47701 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C5.93001 20 2.43001 17.57 0.868008 14.081Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysisHub);
export default __webpack_public_path__ + "static/media/analysis-hub.aab9182a.svg";
export { ForwardRef as ReactComponent };